import React from 'react';
import LeftMenu from './LeftMenu';

import { host } from '../../assets/options';

const ProgramCard = props => {
    var item = props.data;
    return (
        <div className="program-card">
            <div className="program-card-img" style={{backgroundImage: `url(${item.img !== ''?`${host}/public/uploads/${item.img}`:''})`}}></div>
            <div className="program-card-body">
                <div className="program-card-name">{item.name}</div>
                <div className="program-card-links">
                    {item.custom_urls && item.custom_urls[0] && item.custom_urls[0].url ?
                        <a href={item.custom_urls[0].url} target="_blank" rel="noopener noreferrer" className="program-card-link">{item.custom_urls[0].text}</a>:null}
                    {item.custom_urls && item.custom_urls[1] && item.custom_urls[1].url ?
                        <a href={item.custom_urls[1].url} target="_blank" rel="noopener noreferrer" className="program-card-link">{item.custom_urls[1].text}</a>:null}
                </div>
            </div>
        </div>
    );
}

const CompanySection = props => {
    const company = props.company;
    const programs = props.programs;
    return (
        <div className="company-section">
            <div className="company-header">
                {company.logo ?
                    <a href={company.website || company.facebook || '#'} target="_blank" rel="noopener noreferrer" className="company-logo-link">
                        <img className="company-logo" src={`${host}/public/uploads/${company.logo}`} alt={company.name} />
                    </a>
                    :null}
                <div className="company-info">
                    <div className="company-name">{company.name}</div>
                    <div className="company-links">
                        {company.website ?
                            <a href={company.website} target="_blank" rel="noopener noreferrer" className="company-link">
                                <i className="company-link-icon website-icon"></i>
                                Կայքէջ
                            </a>
                            :null}
                        {company.facebook ?
                            <a href={company.facebook} target="_blank" rel="noopener noreferrer" className="company-link">
                                <i className="company-link-icon fb-icon"></i>
                                Facebook
                            </a>
                            :null}
                    </div>
                </div>
            </div>
            <div className="company-programs-grid">
                {programs.map((program, i) => {
                    return <ProgramCard key={i} data={program} />;
                })}
            </div>
        </div>
    );
}

class Items extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAll: false,
            items: []
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            items: nextProps.data
        });
    }

    loadItems () {
        var items = [];
        let mql = window.matchMedia('(max-width: 1024px)').matches;

        let data = this.state.items;
        let length = (!this.state.showAll && mql && data.length > 2) ? 2 : data.length;

        for(var i = 0; i < length; i++){
            items.push(<CompanySection key={i} company={data[i].company} programs={data[i].programs} />);
        }

        if(!this.state.showAll && mql && data.length > 2) {
            items.push(<button key="seeMore" className="seeMoreBtn" onClick={()=>{this.setState({showAll: true})}}>
                Տեսնել բոլորը
            </button>);
        }

        return items;
    }

    getTotalPrograms() {
        let total = 0;
        if(this.state.items) {
            this.state.items.forEach(group => {
                total += group.programs.length;
            });
        }
        return total;
    }

    render(){
        return(
            <React.Fragment>
                <div className="MyBodyContainer InMenu programs">
                    <LeftMenu this={this.props.this}/>

                    <div className="list-with-filter">
                        <div className="ResultsContainer">
                            <div style={{flex: 1}}></div>
                            <p className="SeachResults myprog">
                                Գտնվել է {this.getTotalPrograms()} ընթացիկ ծրագիր
                            </p>
                        </div>

                        <div className="company-sections-container">
                            {this.loadItems()}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default Items;
